<template>
  <div class="content_warp">
    <el-page-header @back="goBack" content="提现日志"></el-page-header>
    <el-row class="no-data">
      <el-col :span="18" :offset="3">
        <div class="cash_content_warpper">
          <!--判断为空-->
          <div class="emptyDataCenter" v-if="list_data.length == 0">
            <emptyData></emptyData>
          </div>
          <div v-else class="content_warpper order_content">
            <div v-for="item in list_data" :key="item.index">
              <el-card shadow="hover">
                <div slot="header" class="text-left card-header-custom">
                  <span>提现编号：</span>
                  <span class="orderNumber" v-text="item.cashNumber"></span>
                  <div class="orderStatus">
                    <el-tag type="Info" v-if="item.status === 0">{{
                      item.status_dictText
                    }}</el-tag>
                    <el-tag type="danger" v-if="item.status === -1">{{
                      item.status_dictText
                    }}</el-tag>
                    <el-tag type="success" v-if="item.status === 1">{{
                      item.status_dictText
                    }}</el-tag>
                  </div>
                </div>
                <div class="main-content text item">
                  <div class="orderBody">
                    <table>
                      <tr>
                        <td>
                          <div class="time">
                            银行卡号：
                            <span v-text="item.card"></span>
                          </div>
                        </td>
                        <td>
                          <div class="main_title">
                            <div class="orderTeacherName time">
                              提现金额:
                              <span v-text="item.money"></span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="orderPrice time">
                            <span v-text="item.createTime"></span>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </el-card>
            </div>
            <!--分页区-->
            <el-row type="flex" justify="end">
              <el-col :span="18" :offset="8">
                <el-pagination @current-change="currentPageChange" :page-size="pageList.size" :current-page="pageList.current" layout="total, prev, pager, next" :total="pageList.total"></el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import util from "@/utils";
import { getCashout } from "@/api/index.js";
import emptyData from "@/components/common/emptyData";
export default {
  data () {
    return {
      list_data: "",
      pageList: "",
      pageSize: 10,
      pageNo: 1,
    };
  },
  components: {
    emptyData,
  },
  methods: {
    goTo (name) {
      this.$router.push({
        name: name,
      });
    },
    goBack () {
      this.$router.go(-1); //返回上一层
      // this.$router.push({
      //   path:'/index/user/addCash'
      // })
    },
    currentPageChange (val) {
      console.log("val", val);
      this.pageNo = val;
      this.readyList();
    },
    async readyList () {
      try {
        let order_status = this.status;
        if (order_status === "0") {
          order_status = "";
        }
        const params = {
          pageSize: this.pageSize,
          pageNo: this.pageNo,
        };
        let res = await getCashout(params)
        if (res.success) {
          this.list_data = res.result.records;
          console.log(this.list_data, "this.list_data");
          this.pageList = res.result;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted () {
    this.readyList();
  },
};
</script>
<style  scoped>
.nodata_warpper {
  width: 500px;
}

.el-page-header {
  margin: 20px 0 0 20px;
}

.content_warp .add-plan {
  line-height: 0px;
  text-align: left;
}
.content_warp .add-plan-btn {
  line-height: 40px;
  float: right;
  margin-right: 10px;
  color: #04ae4e;
  font-size: 20px;
  font-weight: bold;
}

.content_warp .card-header-custom span {
  line-height: 30px;
}
.content_warp .el-button {
  width: 100px;
}
.content_warp .el-card {
  margin-top: 10px;
  font-size: 14px;
}
.content_warp .footer {
  padding: 18px 20px;
}
/*.cash_content_warpper .el-tabs--border-card > .el-tabs__content {*/
/*  height: 0;*/
/*  padding: 0;*/
/*  margin: 0;*/
/*}*/

.content_warp .orderStatus {
  float: right;
}
.content_warp .time {
  font-size: 11px;
  color: #999;
  display: block;
}
.content_warp .el-card__body {
  padding: 20px;
  text-align: left;
}
.content_warp .orderTitle {
  margin-top: 5px;
  display: block;
  padding: 12px;
  font-size: 16px;
  background: rgba(235, 244, 241, 1);
  background-repeat: no-repeat;
  border: 1px solid rgba(235, 244, 241, 0.7);
}

.content_warp .orderTitle span {
  margin-left: 15px;
}

.content_warp .main_title {
  text-align: left;
  font-family: verdana, arial, sans-serif;
  line-height: 1.85rem;
  justify-content: left;
  vertical-align: top;
  display: inline-block;
}
.content_warp .order {
  margin-left: 5px;
  display: inline;
}

.content_warp .orderBody table {
  width: 100%;
  height: auto;
}
.orderBody table tr td {
  text-align: center;
  padding: 10px;
  border: 1px solid #ebeef5;
}
.orderBody table tr td .avator image {
  height: 98px;
}

.cash_content_warpper .content_warpper {
  line-height: 1.25rem;
  position: relative;
  padding: 24px 12px 18px 24px;
}
.cash_content_warpper .content_warpper .main-content {
  display: block;
  width: auto;
}
</style>
